// @ts-nocheck
import React, { useRef } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
  Chip,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ButtonWithLoader from 'commons/containers/ButtonWithLoader';
import AutomationSection from './AutomationSection';

function ProcessTypeForm(props) {
  const { t } = useTranslation();
  const automationRef = useRef();

  const {
    hasAutomationPermission,
    products = {},
    processTypes = {},
    isOpen,
    toggleForm,
    controls,
    invalidControls,
    changeControls,
    edit,
    editingId,
    submit,
  } = props;

  const handleLocalSubmit = () => {
    let payload = { ...controls };

    if (hasAutomationPermission) {
      const result = automationRef.current.getPayload();
      if (!result.isValid) return;
      payload = { ...payload, ...result.payload };
    }

    submit(payload);
  };

  return (
    <Dialog fullWidth onClose={toggleForm} open={isOpen}>
      <DialogTitle>
        {edit ? t('Edit process type') : t('Create process type')}
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.name || ''}
              onChange={changeControls}
              fullWidth
              id="name"
              label={t('Name')}
              error={invalidControls.name}
              helperText={invalidControls.name && t('Name required')}
            />
          </Grid>

          <Grid item sm={6} xs={12}>
            <Box display="flex" flexDirection="column">
              <Typography variant="body2" color="textSecondary">
                {t('Configured loss percentage')}
              </Typography>
              <Chip label={`${controls.loss || 0}%`} variant="outlined" />
            </Box>
          </Grid>

          <Grid item sm={6} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!controls.allowMultipleLots}
                  onChange={changeControls}
                  id="allowMultipleLots"
                  color="primary"
                />
              }
              label={t('Allow multiple lots')}
            />
          </Grid>

          <Grid item sm={6} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!controls.allowMultipleFruits}
                  onChange={changeControls}
                  id="allowMultipleFruits"
                  color="primary"
                />
              }
              label={t('Allow multiple species')}
            />
          </Grid>

          {hasAutomationPermission && (
            <AutomationSection
              ref={automationRef}
              controls={controls}
              products={products}
              processTypes={processTypes}
              editingId={editingId}
              edit={edit}
              isOpen={isOpen}
            />
          )}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={toggleForm} color="primary">
          {t('CANCEL')}
        </Button>
        <ButtonWithLoader onClick={handleLocalSubmit} buttonId="create-edit-processType">
          {edit ? t('Edit') : t('Add')}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
}

export default ProcessTypeForm;